import { useState } from "react";
import { toast } from "sonner";
import { Flame } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function NewsletterForm({ compact = false }) {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email, lang });
      toast.success(t("newsletter_success"));
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err) || t("newsletter_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="newsletter-form" onSubmit={submit}
      className={`flex w-full ${compact ? "max-w-md" : "max-w-lg"} gap-2`}>
      <Input
        data-testid="newsletter-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("newsletter_placeholder")}
        className="bg-white/5 border-white/15 text-hell-bone placeholder:text-hell-bone/40 rounded-full px-5 h-12"
      />
      <Button
        data-testid="newsletter-submit"
        type="submit"
        disabled={loading}
        className="rounded-full bg-hell-red hover:bg-hell-redhot text-hell-bone font-cinzel tracking-[0.15em] uppercase text-xs px-6 h-12 transition-all duration-300 hover:shadow-[0_0_20px_rgba(139,0,0,0.6)]"
      >
        <Flame className="w-4 h-4 mr-2" />
        {loading ? "…" : t("newsletter_cta")}
      </Button>
    </form>
  );
}
